module.exports = __webpack_public_path__ + "static/media/no-data.581db549.svg";